import { logTaggedMessage } from '../../reporter';
import { stringify } from '../../../utils';
import { renderIframeAndWaitForPostback, ThreeDsFormattingException, } from '../3d-secure';
import { threeDsErrors } from '../3ds-utils';
import { removeChallengeIframe } from '../iframe-handler';
const log = logTaggedMessage({ module: '3ds', sub_module: 'adyen_v1fallback' });
const parseV1FallbackPostData = (postData) => {
    if (typeof postData !== 'object' ||
        !postData.PaRes ||
        !postData.MD) {
        throw new ThreeDsFormattingException(`failed to decode invalid V1FallbackResponsePostData.cres: ${stringify(postData)}`);
    }
    return postData;
};
export const performV1Fallback = async ({ methodUrl, data: actionData, provider, notificationUrl, }) => {
    const { md, paRequest } = actionData;
    const success = ({ MD, PaRes, }) => ({
        v1FallbackData: {
            received: {},
            provider,
            data: {
                md: MD,
                paResponse: PaRes,
                shopperIp: '',
            },
        },
    });
    const fail = (error) => {
        return {
            v1FallbackData: {
                provider,
                notReceived: { error },
                data: {
                    md: '',
                    paResponse: '',
                    shopperIp: '',
                },
            },
        };
    };
    const postData = {
        PaReq: paRequest,
        TermUrl: notificationUrl,
        MD: md,
    };
    const logData = {
        actionData,
        methodUrl,
        provider,
        postData,
    };
    log('3ds: before render 3ds Adyen V1fallback iframe', logData);
    const v1FallbackResultPromise = renderIframeAndWaitForPostback('visible', methodUrl, 'POST', postData).then(parseV1FallbackPostData);
    try {
        const v1FallbackResult = await v1FallbackResultPromise;
        log('3ds: received Adyen v1Fallback success', {
            ...logData,
            v1FallbackResult,
        });
        return success(v1FallbackResult);
    }
    catch (e) {
        const ret = fail(threeDsErrors.generate3dsError({
            providerFlow: 'Fallback',
            step: 'challenge',
            e,
        }));
        log('3ds: Adyen v1Fallback ERROR', {
            ...logData,
            e,
            ret,
        });
        return ret;
    }
    finally {
        removeChallengeIframe();
    }
};
//# sourceMappingURL=adyen-v1fallback.js.map